import Component from 'core/Component';
import { Event } from 'services/EventEmitter';
import { deepMerge } from 'toolbox/deepMerge';

/**
 * This is a description of the ResultsCount constructor function.
 * @class
 * @classdesc This is a description of the ResultsCount class.
 * @extends Component
 */
export default class ResultsCount extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     *
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options That belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            dataModelId: null,
            templateName: null,
            total: 0,
        }, options));
    }

    /**
     * Init the different state of the component
     * It helps to avoid heavy DOM manipulation
     */
    initState() {
        this.total = this.options.total || 0;
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonymous function
     */
    bindEvents() {
        Event.on('search.updated', this.onSearchUpdated, this);
    }

    /**
     * Search Updated event handler
     *
     * @param {Object} data Data due to refinement to be changed
     * @param {Boolean} isInsertMode Flag due to a insertion
     */
    onSearchUpdated(data, isInsertMode) {
        if (!data || isInsertMode || !this.options.dataModelId || !data[this.options.dataModelId]) {
            return;
        }
        const currentComponent = data[this.options.dataModelId];

        if (this.options.dataModelId === 'resultscount' && currentComponent.total !== this.total) {
            this.total = currentComponent.total;
            this.element.innerHTML = currentComponent.text.results;
        } else {
            this.render(currentComponent);
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        Event.removeListener('search.updated', this.onSearchUpdated, this);
    }
}
